import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const actionTypes = {
  setCredentials: "[ResetPassword.setCredentials] Action"
};

const INITIAL_STATE = {
  email: "",
  password: "",
  rememberMe: false
};

export const resetPasswordReducer = persistReducer(
  { storage, key: "resetPassword", whitelist: ["email", "password"] },
  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case actionTypes.setCredentials: {
        return {
          ...state,
          email: action.payload.email,
          password: action.payload.password,
          rememberMe: action.payload.rememberMe
        };
      }
      default:
        return state;
    }
  }
);

export const resetPasswordActions = {
  setCredentials: credentials => ({
    type: actionTypes.setCredentials,
    payload: credentials
  })
};
